import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import transformHref from 'core/utils/transformHref';
import {
	CategorySpan,
	CollapsedItemsDropdown,
	NavCategoryMoreContainer,
	NavWidthMediaQueries,
} from './navCategoryBarStyles';

class MoreDropdown extends PureComponent {
	/* Since this requires special styles to hide
	 * hard-code the slugs that may appear in "More" dropdown
	 * ⚠️ There must be cooresponding styles for these in `navCategoryBarStyles.js`
	 */
	collapsibleSlugs = [
		"spiritual-subscription-boxes",
		"home-garden-subscription-boxes",
		"novelty-subscription-boxes",
		"unique-subscription-boxes",
	]

	render () {
		const { collapsibleSlugs } = this;
		const navItems = this.props.navItems.filter(({ slug }) => collapsibleSlugs.includes(slug));
		return (
			<NavCategoryMoreContainer className="dropdown">
				<NavWidthMediaQueries />
				<CategorySpan as="button" className="dropdown-toggle" catType="button" data-cj="dropdown">
					More <span className="caret"></span>
				</CategorySpan>
				<CollapsedItemsDropdown className="dropdown-menu">
					{navItems.map(navItem => {
						const slug = navItem.slug;
						const type = navItem.type;
						const href = navItem.href ? navItem.href : transformHref({ slug, type });
						return (
							<li data-slug={navItem.slug} key={`moredd-${navItem.slug}`}>
								<a href={href}>
									{navItem.long}
								</a>
							</li>
						);
					})}
				</CollapsedItemsDropdown>
			</NavCategoryMoreContainer>
		);
	}

	static propTypes = {
		navItems: PropTypes.array.isRequired,
	}

	static defaultProps = {
		navItems: [],
	}
}

export default MoreDropdown;
